import { CommandItem } from '@cobliteam/ui/components/Command';
import { cn } from '@cobliteam/ui/utils';
import { activeBarColor } from '../helpers';
import { useSearch } from '../hooks/useSearch';
import { type DeviceWithCategory, EnumCategory, type OramaIaWithCategory, type VehicleWithCategory } from '../types';
import { ItemContent } from './ItemContent';
import ArticleIAItem from './entities/ArticleIA/ArticleIAItem';
import DeviceItem from './entities/Device/DeviceItem';
import VehicleItem from './entities/Vehicle/VehicleItem';
interface VirtualizedItemProps {
  virtualRow: { index: number; start: number };
}

export const VirtualizedItem = ({ virtualRow }: VirtualizedItemProps) => {
  const { setSelectedItem, results, category, search, selectedItem } = useSearch();
  const resultsByCategory = category.id === EnumCategory.ALL ? results : results.filter((item) => item?.category?.id === category.id);

  const sortedItems = search
    ? resultsByCategory
    : resultsByCategory.sort((a, b) => {
        const aLabel = a[category.labelKey as keyof typeof a];
        const bLabel = b[category.labelKey as keyof typeof b];
        return String(aLabel).localeCompare(String(bLabel));
      });

  const item = sortedItems[virtualRow.index];
  if (!item) return null;

  const isActive = selectedItem?.id === item.id;

  return (
    <CommandItem
      key={virtualRow.index}
      onSelect={() => setSelectedItem(item)}
      className={cn(
        isActive && 'bg-gray-2 text-gray-12 shadow-none after:bg-primary',
        isActive && activeBarColor(item.category.color),
        '!top-0 !left-0 !w-full !h-50 absolute rounded-none border-gray-4 border-b',
        'after:absolute after:inset-y-0 after:start-0 after:w-[2px]'
      )}
      style={{
        transform: `translateY(${virtualRow.start}px)`,
      }}
    >
      {item.category.id === EnumCategory.VEHICLES && <VehicleItem item={item as VehicleWithCategory} />}
      {item.category.id === EnumCategory.DRIVERS && <ItemContent item={item} />}
      {item.category.id === EnumCategory.VEHICLE_GROUPS && <ItemContent item={item} />}
      {item.category.id === EnumCategory.DEVICES && <DeviceItem item={item as DeviceWithCategory} />}
      {item.category.id === EnumCategory.IA_ARTICLES && <ArticleIAItem item={item as OramaIaWithCategory} />}
      {item.category.id === EnumCategory.ARTICLES && <ItemContent item={item} />}
    </CommandItem>
  );
};
